<template>
  <div id="app">
    <router-view :key="key" />
  </div>
</template>

<style scoped>

</style>
<script>
export default {
  data() {
    return {};
  },
  created(){
    
  },
  computed: {
    key() {
      return this.$route.path + Date.now(); 
    }
  },
  mounted(){
    
  },
  methods:{
    
  },
};
</script>
